import { store } from '@/app/store';
import { updateMediaStatus } from '@/features/chats/model/conversation/reducer';
import { deleteProgress } from '@/features/chats/model/conversation/progressReducer';

export const MEDIA_TYPE_MAP = {
   audio: audioType => (audioType === 'recording' ? 'audio_recorded' : 'audio'),
   file: () => 'file',
};

export const updateMediaUploadStatus = ({ chatId, msgId, is_uploading, is_downloaded, blobUrl }) => {
   store.dispatch(updateMediaStatus({ chatId, msgId, is_uploading, is_downloaded, blobUrl }));
};

export const clearMediaUploadProgress = msgId => {
   store.dispatch(deleteProgress({ msgId }));
};
